import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  input
} from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators
} from '@angular/forms';
import { PhoneNumber } from '@moxi.gmbh/moxi-typescriptmodels';
import { TranslatePipe } from '@ngx-translate/core';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';

@Component({
  selector: 'moxi-phone-number',
  imports: [
    FormsModule,
    ReactiveFormsModule,

    TranslatePipe,

    // Ant Design
    NzFormModule,
    NzInputModule
  ],
  templateUrl: './phone-number.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PhoneNumberComponent implements OnInit {
  formGroup = input.required<FormGroup>();
  phoneNumber = input.required<PhoneNumber>();
  required = input(false);
  showTitle = input(true);
  controlName = input('phoneNumber');
  labelI18nKey = input('global.phoneNumber');

  ngOnInit(): void {
    this.formGroup()?.setControl(
      this.controlName(),
      new FormControl(this.phoneNumber(), {
        validators: [
          this.required() ? Validators.required : Validators.minLength(8),
          Validators.pattern(/^\+\d+/)
        ]
      })
    );
  }
}
